import React from 'react';
import { saveLogo } from '../../data/serviceLeadgen';
import { ActionTabs } from '../../helpers/uiComponents/ActionTabs';
import { CloseProfile } from '../../helpers/uiComponents/CloseProfile';
import { InputRow } from '../../helpers/uiComponents/InputRow';
import { accordian } from '../../helpers/uiFunctions/uiActions';

class NfaProfile extends React.Component {
    constructor(props) {
        super(props);
        this.updateRetailer = this.updateRetailer.bind(this);
        this.updateLocation = this.updateLocation.bind(this);
    }
    updateRetailer(e) {
		var key = e.target.name;
		var value = e.target.value;

		var type = e.target.type;
		if (type === "checkbox") {
			value = e.target.checked
		}
		var update = this.props.updateRetailer
        update(key, value);
	}
    updateLocation(e) {
        var index = e.target.attributes.customdata.value;
		var key = e.target.name;
		var value = e.target.value;

		var type = e.target.type;
		if (type === "checkbox") {
			value = e.target.checked
		}
		var update = this.props.updateLocation
        update(index, key, value);
	}
    saveImage() {
		var logoInput = document.getElementById("retailer-logo");
		var logo = new FormData();
		var retailerCode = this.props.retailer.retailerCode;

		logo.append('logo', logoInput.files[0]);
		//console.log(logo);
		saveLogo(retailerCode, logo).then(response => {
			//console.log(response);
			var update = this.props.updateRetailer
			update("logo", response.result.logo);
		})
	}
    deleteImage() {
		var update = this.props.updateRetailer
		update("logo", null);
	}
    render() {
        const retailer = this.props.retailer;
        //console.log(retailer);
        return(
            <div className="column profile-column" id="nfa-profile-column">
                <div className="profile">
                    {(retailer) && (
                        <React.Fragment>
                            <div className="profile-header">
                                <h3 className="profile-name">{retailer.name}</h3>
                                <CloseProfile />
                            </div>
                            <div className="profile-form">
                                <div className="input-group">
                                    <div className="accordian-title" onClick={accordian}>
                                        <h4>Retailer Information</h4>
                                    </div>
                                    <div className="accordian-body">
                                        <ActionTabs 
                                            handleSave={this.props.saveRetailer}
                                            id={"nfa-store"}
                                        />
                                        <div id="retailer-account-inputs" className="inputs">
                                            <InputRow onChange={this.updateRetailer} label="Retailer Name" type="text" value={retailer.name} property="name" />
                                            <InputRow label="Client Code" type="text" value={retailer.clientCode} property="clientCode" disabled />
                                            <div className="input-row">
                                                <label htmlFor="logo">Retailer Logo</label>
                                                <div>
                                                    <input type="file" name="logo" id="retailer-logo" onChange={() => this.saveImage()} filename={retailer.logo} />
                                                    <p>Max Image Size is 1MB, All images should be .jpg or .png</p>
                                                    {(retailer.logo) && (
                                                        <div className="image-container">
                                                            <img src={"https://"+retailer.logo} alt={retailer.name} id="img-logo" />
                                                            <p>src="https://{retailer.logo}"</p>
                                                            <div className="delete-img"><i className="fas fa-times icon" onClick={() => this.deleteImage()}></i></div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="input-group">
                                    <div className="accordian-title" onClick={accordian}>
                                        <h4>Store Locations</h4>
                                    </div>
                                    <div className="accordian-body">
                                        <ActionTabs
                                            handleSave={this.props.saveLocations}
                                            tabs={retailer.locations}
                                            id={"nfa-store"}
                                        />
                                        <div id="nfa-store-inputs" className="inputs">
                                            {retailer.locations.map((location, index) =>
                                                <div key={index} id={"nfa-store-"+index} className={"tab nfa-store-"+index}>
                                                    <InputRow label="Client Code (code used by MM to identify a location, stable)" type="text" value={location.clientCode} property="clientCode" disabled />
                                                    <InputRow label="Location Code (code used by client to identify their locations, unstable, aka Dealer ID)" type="text" value={location.locationCode} property="locationCode" disabled />

                                                    <InputRow onChange={this.updateLocation} data={index} label="Name" type="text" value={location.name} property="name" />
                                                    <InputRow onChange={this.updateLocation} data={index} label="Address 1" type="text" value={location.address1} property="address1" />
                                                    <InputRow onChange={this.updateLocation} data={index} label="Address 2" type="text" value={location.address2} property="address2" />
                                                    <InputRow onChange={this.updateLocation} data={index} label="City" type="text" value={location.city} property="city" />
                                                    <InputRow onChange={this.updateLocation} data={index} label="State" type="text" value={location.state} property="state" />
                                                    <InputRow onChange={this.updateLocation} data={index} label="Country" type="text" value={location.country} property="country" />
                                                    <InputRow onChange={this.updateLocation} data={index} label="Postal Code" type="text" value={location.postalCode} property="postalCode" />
                                                    <InputRow onChange={this.updateLocation} data={index} label="Latitude" type="text" value={location.lat} property="lat" />
                                                    <InputRow onChange={this.updateLocation} data={index} label="longitude" type="text" value={location.lng} property="lng" />
                                                    <InputRow onChange={this.updateLocation} data={index} label="Store Phone Number" type="text" value={location.phone} property="phone" />
                                                    <InputRow onChange={this.updateLocation} data={index} label="Forwarding Phone Number" type="text" value={location.forwardingPhone} property="forwardingPhone" />
                                                    <InputRow onChange={this.updateLocation} data={index} label="Store Contact Email" type="text" value={location.email} property="email" />
                                                    <InputRow onChange={this.updateLocation} data={index} label="Website URL" type="text" value={location.url} property="url" />
                                                    <div className="input-row">
                                                        <label>
                                                            {location.urls.map((url, index) =>
                                                                <div key={index}>
                                                                    <strong>{url.type} Pages</strong>
                                                                    <p id={url.type} data-id={url.urlId}>SEO URL: {url.seo}</p><br/>
                                                                    <p id={url.type} data-id={url.urlId}>SEM URL: {url.sem}</p><br/>
                                                                </div>
                                                            )}
                                                        </label>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </div>
        )
    }
}
export default NfaProfile;


// WEBPACK FOOTER //
// ./src/component_nfa/NfaProfile/Profile.js